<template>
  <div :class="['tripla-faq-widget', { 'tripla-faq-widget--show': show }]">
    <transition name="fade">
      <iframe v-if="showIframe" :key="iframeKey" :src="iframeSrc"></iframe>
    </transition>
  </div>
</template>

<script>
import { appID } from 'javascript/Constants'
import { useAppStore } from 'Store/app'
import { EventBus } from '../ChatWidget/EventBus'

export default {
  name: 'FaqWidgetApp',

  setup() {
    const appStore = useAppStore()

    return { appStore }
  },

  props: {
    elements: { type: Array, default: () => [] },
    openAction: { type: String, default: undefined }
  },

  data() {
    return {
      show: false,
      showIframe: false,
      chatbotZIndex: 0,
      iframeKey: 1,
      faqWidgetURL: process.env.FAQ_WIDGET_URL,
      chatWidgetReady: this.$attrs.chatWidgetReady,
      isMounted: false
    }
  },

  computed: {
    iframeSrc() {
      const url = new URL(this.faqWidgetURL)
      url.searchParams.set('facility_code', this.appStore.websiteFacilityCode)
      url.searchParams.set('parent_url', window.location.origin)

      return url.toString()
    },
    shouldAutoOpen() {
      return this.chatWidgetReady && this.openAction && this.isMounted
    }
  },

  watch: {
    shouldAutoOpen: {
      immediate: true,
      handler(shouldAutoOpen) {
        if (shouldAutoOpen) {
          this.$nextTick(() => this.open())
        }
      }
    },
    show: {
      immediate: true,
      handler(show) {
        // logic for non-requestAnimationFrame browsers.
        if (!window.requestAnimationFrame) {
          this.showIframe = show
        }
      }
    }
  },

  mounted() {
    this.$el.addEventListener('transitionend', () => {
      this.showIframe = this.show
    })

    // due to chrome bug, https://bugs.chromium.org/p/chromium/issues/detail?id=675795
    // $nextTick is not working here, double requestAnimationFrame is the only way to wait DOM painted
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(() =>
        window.requestAnimationFrame(() => {
          this.isMounted = true
        })
      )
    }
  },

  created() {
    window.addEventListener('message', (m) => {
      if (m.origin !== this.faqWidgetURL) return

      if (m.data.action === 'close') {
        this.close()
      }
    })

    this.elements.forEach((el) => {
      el.addEventListener('click', () => this.open())
    })

    // wait chat widget ready before open
    EventBus.$on('chat-widget-ready', () => {
      this.chatWidgetReady = true
    })
  },

  methods: {
    close() {
      this.show = false
      this.showIframe = false
      document.body.style.setProperty('overflow', null)
      document.getElementById(appID).style.setProperty('z-index', this.chatbotZIndex)
    },
    open() {
      if (this.show) return

      this.show = true
      this.iframeKey++ // force re-render iframe

      const chatbotContainer = document.getElementById(appID)
      this.chatbotZIndex = chatbotContainer.style.zIndex
      document.getElementById(appID).style.setProperty('z-index', '0')
    }
  }
}
</script>

<style lang="scss" scoped>
.tripla-faq-widget {
  transform: scaleY(0);
  transform-origin: center bottom;
  transition: all 0.5s ease-in-out;
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  z-index: 2147483647;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;

  &--show {
    transform: scaleY(1);
  }

  iframe {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2147483647;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
